import { ChatFilled } from 'src/shared/components/icons/chat/chat-filled'
import { BriefcaseFilled } from 'src/shared/components/icons/referrals/briefcase-filled'
import { Star } from 'src/shared/components/icons/star'
import { Users } from 'src/shared/components/icons/users'
import type { ChatType } from 'src/shared/schemas/chats/chat-data'

interface ChannelSymbolProps {
  type: ChatType
  className?: string
  iconSize?: number
}

export const ChannelSymbol = ({ type, className = 'size-5', iconSize = 11 }: ChannelSymbolProps) => {
  switch (type) {
    case 'referral':
      return (
        <div
          className={`flex items-center justify-center rounded-md bg-secondaryInverse ring-1 ring-background ${className}`}
        >
          <BriefcaseFilled size={iconSize} className="text-primary" />
        </div>
      )
    case 'partner-match':
      return (
        <div
          className={`flex items-center justify-center rounded-md bg-partnerMatch ring-1 ring-background ${className}`}
        >
          <Star size={iconSize} className="text-white" />
        </div>
      )
    case 'network':
      return (
        <div className={`flex items-center justify-center rounded-md bg-primary ring-1 ring-background ${className}`}>
          <Users size={iconSize} className="text-white" />
        </div>
      )
    case 'sneak':
      return (
        <div className={`flex items-center justify-center rounded-md bg-sneak ring-1 ring-background ${className}`}>
          <ChatFilled size={iconSize} className="text-white" />
        </div>
      )
    default:
      throw new Error(`Unexpected chat type: ${type}`)
  }
}
